
export const ClassTransform = {
  Server: {
    excludeExtraneousValues: true, exposeDefaultValues: true, enableImplicitConversion: true
  },
  Browser: {exposeDefaultValues: true, enableImplicitConversion: true}
}